var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 9.18945 11.6846",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 11.6846,
    opacity: 0,
    width: 9.18945,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62305 6.20117C8.62305 3.81836 6.69434 1.88965 4.31152 1.88965C4.01367 1.88965 3.72559 1.92383 3.47168 1.97266L4.77051 0.678711C4.83887 0.600586 4.87793 0.50293 4.87793 0.400391C4.87793 0.175781 4.71191 0 4.49219 0C4.375 0 4.27734 0.0390625 4.20898 0.117188L2.19727 2.1582C2.11914 2.23633 2.0752 2.34375 2.0752 2.45117C2.0752 2.56348 2.10938 2.66113 2.19727 2.74414L4.20898 4.76562C4.28223 4.83398 4.37012 4.87793 4.49219 4.87793C4.71191 4.87793 4.87793 4.71191 4.87793 4.4873C4.87793 4.38477 4.84375 4.28223 4.76562 4.20898L3.30566 2.76367C3.59375 2.69531 3.94043 2.6709 4.31152 2.6709C6.25977 2.6709 7.83691 4.24805 7.83691 6.19629C7.83691 8.14453 6.25977 9.72168 4.31152 9.72168C2.36328 9.72168 0.786133 8.14453 0.786133 6.19629C0.786133 5.96191 0.639648 5.79102 0.405273 5.79102C0.166016 5.79102 0 5.96191 0 6.20117C0 8.58398 1.92871 10.5127 4.31152 10.5127C6.69434 10.5127 8.62305 8.58398 8.62305 6.20117Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.ae5843de16801143fbed3dff2f138c6f.svg";
export { ForwardRef as ReactComponent };